import { render, staticRenderFns } from "./DiceControl.vue?vue&type=template&id=1df12e9e&scoped=true"
import script from "./DiceControl.vue?vue&type=script&lang=js"
export * from "./DiceControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df12e9e",
  null
  
)

export default component.exports